<template>
  <v-app dark>
    <v-col>
      <ValidationObserver ref="pollValidation"
                          v-slot="{ invalid, passes }">
        <v-row>
          <v-col
            cols="12">
            Změna tělesné hmotnosti v poslední době (úbytek/přírůstek)
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              rules="required"
              v-model="form.changeBodyWeight.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       value="1" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       value="2" />
              <v-radio color="blue lighten-1"
                       label="Nechci uvést"
                       value="4" />
            </VRadioWithValidation>
          </v-col>
          <v-col>
            <v-text-field
              class="mt-0 pt-0"
              label="Úbytek (kg)"
              v-model="form.changeBodyWeight.value.down"
              :disabled="String(form.changeBodyWeight.status) !== '1' || (form.changeBodyWeight.value.up.length ? true : false)" />
          </v-col>
          <v-col>
            <v-text-field
              class="mt-0 pt-0"
              label="Přírůstek (kg)"
              v-model="form.changeBodyWeight.value.up"
              :disabled="String(form.changeBodyWeight.status) !== '1' || (form.changeBodyWeight.value.down.length ? true : false)" />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12">
            Trpíte gastrointestinálními obtížemi (pálení žáhy, nadýmání, průjem, zácpa, zvracení, křeče a bolesti břicha)
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              rules="required"
              v-model="form.gastrointestinalComplaints.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       value="1" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       value="2" />
              <v-radio color="blue lighten-1"
                       label="Nechci uvést"
                       value="4" />
            </VRadioWithValidation>
          </v-col>
          <v-col>
            <VTextAreaWithValidation
              :rules="form.gastrointestinalComplaints.status == '1' ? 'required' : ''"
              v-model="form.gastrointestinalComplaints.value"
              label="Jaké"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.gastrointestinalComplaints.status != '1'"
              outlined />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12">
            Nesnášenlivost potravin (lepek, laktóza apod.)
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              rules="required"
              v-model="form.foodIntolerance.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       value="1" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       value="2" />
              <v-radio color="blue lighten-1"
                       label="Nevím"
                       value="3" />
            </VRadioWithValidation>
          </v-col>
          <v-col>
            <VTextAreaWithValidation
              :rules="form.foodIntolerance.status == '1' ? 'required' : ''"
              v-model="form.foodIntolerance.value"
              label="Jaké"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.foodIntolerance.status != '1'"
              outlined />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12">
            Konzumujete ve větším množství rizikové potraviny - uzeniny, konzervované potraviny, sladkosti
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              rules="required"
              v-model="form.riskFoods.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       value="1" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       value="2" />
              <v-radio color="blue lighten-1"
                       label="Nechci uvést"
                       value="4" />
            </VRadioWithValidation>
          </v-col>
          <v-col>
            <VTextAreaWithValidation
              :rules="form.riskFoods.status == '1' ? 'required' : ''"
              v-model="form.riskFoods.value"
              label="Jaké/kolikrat týdně"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.riskFoods.status != '1'"
              outlined />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12">
            Bylo u Vás provedeno kolonoskopické vyšetření?
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              rules="required"
              v-model="form.colonoscopy.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       value="1" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       value="2" />
              <v-radio color="blue lighten-1"
                       label="Nechci uvést"
                       value="4" />
            </VRadioWithValidation>
          </v-col>
          <v-col>
            <VTextAreaWithValidation
              :rules="form.colonoscopy.status == '1' ? 'required' : ''"
              v-model="form.colonoscopy.value"
              label="Výsledek vyšetření"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.colonoscopy.status != '1'"
              outlined />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12">
            Bylo u Vás provedeno vyšetření protilátek proti lepku?
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              rules="required"
              v-model="form.antiGluten.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       value="1" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       value="2" />
              <v-radio color="blue lighten-1"
                       label="Nechci uvést"
                       value="4" />
            </VRadioWithValidation>
          </v-col>
          <v-col>
            <VTextAreaWithValidation
              :rules="form.antiGluten.status == '1' ? 'required' : ''"
              v-model="form.antiGluten.value"
              label="Výsledek vyšetření"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.antiGluten.status != '1'"
              outlined />
          </v-col>
          <v-col
            cols="auto">
            <v-btn @click="submit()"
                   type="submit"
                   x-large
                   depressed
                   height="68px"
                   class="px-12 white--text"
                   color="blue lighten-1">
              Uložit
            </v-btn>
          </v-col>
        </v-row>
      </ValidationObserver>
    </v-col>
  </v-app>
</template>

<script>
export default {
  name: 'TheGastroDisorders',
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      form: {
        userId: this.$store.state['vue-auth'].user ? this.$store.state['vue-auth'].user.id : '',
        changeBodyWeight: {
          status: null,
          value: {
            down: '',
            up: ''
          }
        },
        gastrointestinalComplaints: {
          status: null,
          value: ''
        },
        foodIntolerance: {
          status: null,
          value: ''
        },
        riskFoods: {
          status: null,
          value: ''
        },
        colonoscopy: {
          status: null,
          value: ''
        },
        antiGluten: {
          status: null,
          value: ''
        }
      },
    };
  },
  computed: {
    formtosend() {
      // eslint-disable-next-line no-new-object
      return new Object({
        userId: this.$store.state['vue-auth'].user ? this.$store.state['vue-auth'].user.id : '',
        changeBodyWeight: {
          status: Number(this.form.changeBodyWeight.status),
          value: JSON.stringify({
            down: this.form.changeBodyWeight.value.down,
            up: this.form.changeBodyWeight.value.up
          })
        },
        gastrointestinalComplaints: {
          status: Number(this.form.gastrointestinalComplaints.status),
          value: this.form.gastrointestinalComplaints.value
        },
        foodIntolerance: {
          status: Number(this.form.foodIntolerance.status),
          value: this.form.foodIntolerance.value
        },
        riskFoods: {
          status: Number(this.form.riskFoods.status),
          value: this.form.riskFoods.value
        },
        colonoscopy: {
          status: Number(this.form.colonoscopy.status),
          value: this.form.colonoscopy.value
        },
        antiGluten: {
          status: Number(this.form.antiGluten.status),
          value: this.form.antiGluten.value
        }
      });
    }
  },
  methods: {
    async submit() {
      const valid = await this.$refs.pollValidation.validate();

      if (!valid) {
        return false;
      }

      const form = this.formtosend;
      form.CustomerId = this.id;

      document.getElementById('genscanLogoDiv').scrollIntoView();

      this.axios.put('admin/questionnaires/digestivetract', form).then((res) => {
        if (res.status === 200) {
          this.$root.$bvToast.toast(this.$t('Questionnaires.SuccessToast.Body'), {
            title: this.$t('Questionnaires.SuccessToast.Title'),
            variant: 'success',
            toaster: 'b-toaster-top-right'
          });
          this.$emit('completed');
        }
      }).catch(() => {
        this.$root.$bvToast.toast(this.$t('Questionnaires.FailureToast.Body'), {
          title: this.$t('Questionnaires.FailureToast.Title'),
          variant: 'danger',
          toaster: 'b-toaster-top-right'
        });
      });

      return true;
    }
  },
  created() {
    this.axios.get('admin/questionnaires/digestivetract', {
      params: {
        CustomerId: this.id
      }
    }).then((response) => {
      const data = response.data.result;

      this.form = {
        changeBodyWeight: {
          status: String(data.changeBodyWeight.status),
          value: JSON.parse(data.changeBodyWeight.value)
        },
        gastrointestinalComplaints: {
          status: String(data.gastrointestinalComplaints.status),
          value: data.gastrointestinalComplaints.value
        },
        foodIntolerance: {
          status: String(data.foodIntolerance.status),
          value: data.foodIntolerance.value
        },
        riskFoods: {
          status: String(data.riskFoods.status),
          value: data.riskFoods.value
        },
        colonoscopy: {
          status: String(data.colonoscopy.status),
          value: data.colonoscopy.value
        },
        antiGluten: {
          status: String(data.antiGluten.status),
          value: data.antiGluten.value
        }
      };
    });
  }
};
</script>
